var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RichText',{staticClass:"field-footercontent",attrs:{"label":_vm.label,"sublabel":_vm.$attrs.sublabel},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }